import styled from "styled-components";

export const UserMenuBalanceLabelDefaultBox = styled.div`
    white-space: nowrap;
    font-size: 1.4rem;
    color: ${({theme}) => theme.colors.textContrast};
    font-weight: 600;
`;
